// src/layout/AppLayout/AppLogo.js
import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { LogoContainer } from './styles';

/**
 * AppLogo Component
 * Renders the official Readable English brand logo image,
 * adapting cleanly to dark/light modes.
 */
const AppLogo = ({ compact = false }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const logoImage = (
    <Box
      component="img"
      src="https://readablenglish.com/hs-fs/hubfs/Readable%20English%20Logo%20(1).png"
      alt="Readable English Logo"
      sx={{
        height: compact ? 28 : 36,
        objectFit: 'contain',
        filter: isDark ? 'none' : 'invert(1) hue-rotate(180deg)',
        transition: 'filter 0.3s ease',
      }}
    />
  );

  if (compact) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', py: 0.5 }}>
        {logoImage}
      </Box>
    );
  }

  return (
    <LogoContainer sx={{ py: 2.5, px: 2, display: 'flex', justifyContent: 'center' }}>
      {logoImage}
    </LogoContainer>
  );
};

export default AppLogo;